import { ITag } from '../interfaces/IGroup';

export default class Tag {
  tagId: number;
  keyWord: string;

  constructor(tagId: number = 0, tagName: string = '') {
    this.tagId = tagId;
    this.keyWord = tagName;
  }

  static mappingObject(obj: any): ITag {
    return {
      tagId: obj.TagID,
      keyWord: obj.Keyword,
    };
  }

  static mappingArray(_arr: any[]): ITag[] {
    return _arr.map((item: any) => Tag.mappingObject(item));
  }
}
